export const EN_HK = 'en-hk';
export const ZH_HK = 'zh-hk';
export const EN_IN = 'en-in';
